// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimParticipantResponseDto
 */
export interface IClaimParticipantResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimParticipantResponseDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimParticipantResponseDto
     */
    provider_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimParticipantResponseDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimParticipantResponseDto
     */
    service_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimParticipantResponseDto
     */
    category_type?: IClaimParticipantResponseDtoCategoryTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimParticipantResponseDto
     */
    service_on?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimParticipantResponseDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimParticipantResponseDto
     */
    current_claim_status?: IClaimParticipantResponseDtoCurrentClaimStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IClaimParticipantResponseDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IClaimParticipantResponseDtoCurrentClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IClaimParticipantResponseDto interface.
 */
export function instanceOfIClaimParticipantResponseDto(value: object): value is IClaimParticipantResponseDto {
    return true;
}

export function IClaimParticipantResponseDtoFromJSON(json: any): IClaimParticipantResponseDto {
    return IClaimParticipantResponseDtoFromJSONTyped(json, false);
}

export function IClaimParticipantResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimParticipantResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'service_name': json['service_name'] == null ? undefined : json['service_name'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'current_claim_status': json['current_claim_status'] == null ? undefined : json['current_claim_status'],
    };
}

export function IClaimParticipantResponseDtoToJSON(json: any): IClaimParticipantResponseDto {
    return IClaimParticipantResponseDtoToJSONTyped(json, false);
}

export function IClaimParticipantResponseDtoToJSONTyped(value?: IClaimParticipantResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'provider_name': value['provider_name'],
        'service_id': value['service_id'],
        'service_name': value['service_name'],
        'category_type': value['category_type'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString().substring(0,10)),
        'requested_amount': value['requested_amount'],
        'current_claim_status': value['current_claim_status'],
    };
}

